<template>
    <div>
        <v-cookie></v-cookie>
        <div id="usual1" class="usual"> 
            <div class="formbody">
                <div class="formtitle_phone pab10">
                    <div class="left">
                        <ul class="manto">
                            <li @click="addTxt()" class="left w26"><img src="../../assets/images/ico6214.png" alt="文本"  />文本</li>
                            <el-upload class="left w26" 
                                :action=voiceSmsUploadImgUrl
                                accept="image/jpeg,image/gif,image/png"
                                :show-file-list="false"
                                :headers="uploadHeaders"
                                :before-upload="beforeUploadImg"
                                :on-success="uploadImgSuccess"
                                >
                                <img src="../../assets/images/ico6211.png" alt="图片" />图片
                            </el-upload>
                            <el-upload class="left w26"
                                :action=voiceSmsUploadVideoUrl
                                accept=".mp4,.3gp"
                                :show-file-list="false"
                                :headers="uploadHeaders"
                                :before-upload="beforeUploadVideo"
                                :on-success="uploadVideoSuccess"
                                >
                                <img src="../../assets/images/ico6212.png" alt="视频" />视频</el-upload>
                            <el-upload class="left w26"
                                :action=voiceSmsUploadAudioUrl
                                accept=".mp3"
                                :show-file-list="false"
                                :headers="uploadHeaders"
                                :before-upload="beforeUploadAudio"
                                :on-success="uploadAudioSuccess"
                                >
                                <img src="../../assets/images/ico6213.png" alt="音频" />音频</el-upload>
                        </ul>
                    </div>
                    <div class="right">
                        <input class="sure" type="button" value="预览" @click="previewTemplate()">
                        <input class="sure" type="button" value="保存草稿箱" @click="saveDraft()">
                        <input class="sure" type="button" value="提交审核" @click="saveTemplate()">
                    </div>
                </div>
                <div class="templatediv">
                    <div class="templateleft">
                        <div class="phonediv">                                
                            <div  class="phonetop">
                                <img src="../../assets/images/phonetop.jpg" alt="top1" />
                            </div>
                            <div  class="phonebox">
                                <ul> 
                                    <li v-for="(item,index2) in templateList" class="phoneboxa">
                                        <div @click="showTemplate(index2+1)" class="showDiv" :class="{current:item.current}">
                                            <div v-if="item.templateType=='txt'" class="phonetext">{{item.templateContent}}</div>
                                            <div v-else-if="item.templateType == 'img'" class="phoneimg">
                                                <img :src="item.templateContent" title="图片" />
                                            </div>
                                            <div v-else-if="item.templateType=='video'" class="phoneimg">
                                                <!-- <video :src="item.templateContent"  controls="controls" style="width: 240px;" >您的浏览器不支持 video 标签。</video> -->
                                                <img :src="item.poster" title="图片" />
                                            </div>
                                            <div v-else-if="item.templateType=='audio'" class="phoneVF">
                                                <img src="../../assets/images/audio.png" title="音频文件" />
                                            </div>
                                        </div>
                                        <div v-if="index2+1 == index"  class="el-popover el-popper editPopper element">
                                            <ul class="btnList">
                                                <li v-if="index==1"><img src="../../assets/images/ico710.png" alt="上" /></li>
                                                <li v-else @click="moveUp()"><img src="../../assets/images/ico6215.png" alt="上" /></li>
                                                <li v-if="index==templateList.length"><img src="../../assets/images/ico711.png" alt="下" /></li>
                                                <li v-else @click="moveDown()"><img src="../../assets/images/ico6216.png" alt="下" /></li> 
                                                <li @click="delTemplate()"><img src="../../assets/images/ico6217.png" title="删除" /></li>
                                            </ul>
                                        </div>
                                    </li>                                      
                                </ul>
                            </div> 
                        </div> 
                    </div>
                    <div class="templatedivright" >
                                                    
                        <ul class="forminfo" >
                            <li>
                                <label>模板主题</label>
                                <div class="vocation">
                                <input name="" v-model="title" type="text" class="phoneinput" />
                                </div>
                            </li>

                            <li v-if="templateType == '文字内容'">
                                <label>文字内容 </label>
                                <textarea name="" cols="" rows="" @input="setTxtContent()" v-model="templateContent" class="phonetextinput maringht10"></textarea>
                            </li>
                            <li v-else-if="templateType == '图片内容'">
                                <label>图片内容 </label>
                                <div class="wi300">
                                    <img :src="templateContent" alt="图片" />
                                </div>
                                <!-- <div class="wi300 mat5">
                                    <input class="sure right" type="button" value="更换图片">
                                </div> -->
                            </li>
                            <li v-else-if="templateType == '视频内容'">
                                <label>视频内容 </label>
                                <div class="wi300">
                                    <video :src="templateContent" controls="controls" style="width: 240px;">您的浏览器不支持 video 标签。</video>
                                </div>
                                <!-- <div class="wi300 mat5">
                                    <input class="sure right" type="button" value="更换视频">
                                </div> -->
                            </li>
                            <li v-else-if="templateType == '音频内容'">
                                <label>音频内容 </label>
                                <div class="wi300">
                                    <audio :src="templateContent" width="100%" controls="controls">您的浏览器不支持 audio 标签。</audio>
                                </div>
                                <!-- <div class="wi300 mat5">
                                    <input class="sure right" type="button" value="更换视频">
                                </div> -->
                            </li>
                            <li>
                                    
                            <label>模板大小 </label>
                            <div class="flowDiv" style="clear:both">
                                <div class="box">
                                    <div class="" style="background:#ddd;width:200px;height: 6px;border-radius: 5px;position: relative">
                                        <div class="bar" :style='width' id="bar"></div>
                                    </div>
                                </div>
                                <div class="left">1.9M/{{viewSize}}</div>
                            </div>
                            </li>
                        </ul>


                
                        
                        <div class="ma20"> 
                            <h4 class="mab10">提示说明：</h4>
                            <ul>
                                <li class="mab10">1.模板大小500K以上，但不超过1.9MB（发送过小的模板，会导致部分客户收取不到）</li>
                                <li class="mab10">2.模板内容至少有一个文字，文字里必须包含签名，并且签名放在最前面（例如：【二办】您好，这是视频短信），但不能纯文字、纯音频、纯视频、纯图片, 至少两两组合（发送内容单一的模板，会导致部分客户收取不到）</li> 
                                <li class="mab10">3.图片支持jpg、jpeg、gif、png格式，图片总数不能超过10张</li> 
                                <li class="mab10">4.音频支持mp3格式，视频支持mp4、3gp格式</li> 
                            </ul>
                        </div>            
                    </div>
                </div>
            </div>
        </div>
        <!--tip1 预览-->
        <div class="tipp tip1" style="max-height:680px;">        
    	    <div class="tiptop">
                <span>模板预览</span><a></a>
            </div>        
            <div class="tipinfo cen ovhi">      
                <div class="phonediv">                                
                    <div  class="phonetop">
                        <img src="../../assets/images/phonetop.jpg" alt="top1" />
                    </div>
                    <div  class="phonebox">
                        <ul> 
                            <li class="phoneboxa">
                                <div class="showDiv">
                                     <div class="phonetext">{{title}}</div>
                                </div>
                            </li>
                            <li v-for="(item,index2) in templateList" class="phoneboxa">
                                <div class="showDiv">
                                    <div v-if="item.templateType=='txt'" class="phonetext">{{item.templateContent}}</div>
                                    <div v-else-if="item.templateType == 'img'" class="phoneimg">
                                        <img :src="item.templateContent" title="图片" >
                                    </div>
                                    <div v-else-if="item.templateType=='video'" class="phonevideo">
                                        <video :src="item.templateContent"  controls="controls" style="width: 240px;">您的浏览器不支持 video 标签。</video>
                                    </div>
                                    <div v-else-if="item.templateType=='audio'" class="phoneVF">
                                        <img src="../../assets/images/audio.png" title="音频文件" >
                                    </div>
                                </div>
                            </li>                                      
                        </ul>
                    </div> 
                </div> 
            </div>
            <div class="cen pat20 ovhi">
                <input name="" type="button"  class="cancel" @click="close()"  value="关闭" />&nbsp;
                <input name="" type="button"  class="sure" @click="close()"  value="提交审核" />
            </div>    
        </div> 

        <!--tip1 end-->
    </div>
</template>
<script>
import cookie from '@/components/cookie.vue'
import faxsendVue from '../fax/faxsend.vue';
export default {
    components : {
        'v-cookie' : cookie,
    },
    data(){
        return{
            templateList:[],
            index:1,
            templateType:'',
            templateContent:'',  //内容
            templateSize:0,
            viewSize:'0',
            voiceSmsUploadImgUrl:this.GLOBAL.serverSrc + '/upload/uploadvoicesmsimg.json',
            uploadHeaders:{},
            voiceSmsUploadVideoUrl:this.GLOBAL.serverSrc + '/upload/uploadvoicesmsvideo.json',
            voiceSmsUploadAudioUrl:this.GLOBAL.serverSrc + '/upload/uploadvoicesmsaudio.json',
            title:'',
            width:'0%',
            id:'',
            videoSmsTemplate:{},
            size:0,
        }
    },
    mounted(){
        this.uploadHeaders.token = this.GLOBAL.token;
        this.id = this.$route.query.id == null ? "" : this.$route.query.id
        //console.log('id:' + this.id);
        if(this.id !=''){
            this.getTemplateData();
        }
        console.log("mounted");
    },
    methods:{
        getTemplateData(){
            let that = this;
            let data = {'id':this.id};
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/sms/qrytemplatedetail.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token
                }
            }).then(function(res) {
                //console.log(res);
                if('0000000' == res.data.code)
                {
                    that.videoSmsTemplate = res.data.videoSmsTemplate;
                    if(that.videoSmsTemplate != undefined)
                    {
                        that.templateList = JSON.parse(that.videoSmsTemplate.templateContent);
                        that.index = 1;
                        that.calculateSize();
                        that.templateList.forEach(function(cobj){
                            if(cobj.index == 1){
                                cobj.current = true;
                                if(cobj.templateType == 'txt'){
                                    that.templateType = "文字内容";
                                }
                                else if(cobj.templateType == 'img'){
                                    that.templateType = "图片内容";
                                }
                                else if(cobj.templateType == 'video'){
                                    that.templateType = "视频内容";
                                }
                                else if(cobj.templateType == 'audio'){
                                    that.templateType = "音频内容";
                                }
                                that.templateContent = cobj.templateContent;
                            }else{
                                cobj.current = false;  
                            } 
                        });
                        that.title = that.videoSmsTemplate.title;
                        
                    }     
                }
                else
                {
                    alert(res.data.msg)
                }
            })
        },
        addTxt(){
            // console.log("添加文字");
            this.templateList.forEach(function(cobj){
                cobj.current = false;   
            });
            let index = this.templateList.length;
            // console.log('index:' + index);
            this.templateList.push({'index':index+1,'templateType':'txt','templateContent':'','contentCode':'','current':true,'size':0,'poster':''});
            this.templateType = '文字内容';
            index = index + 1;
            this.index = index;
            // console.log('index:：' + index);
            this.templateContent  = '';
        },
        setTxtContent(){
            let that = this;
            
            this.templateList.forEach(function(cobj){
                if(cobj.index == that.index){
                    cobj.templateContent = that.templateContent;
                    cobj.size = that.templateContent.length*3;
                }   
            });
            // this.templateSize = this.templateSize + this.templateContent.length*3;
            this.calculateSize();
        },
        beforeUploadImg(file){
            // console.log(file.type)
            if (['image/jpeg','image/gif','image/png'].indexOf(file.type) == -1) {
                this.$message.error('文件格式暂不支持！');
                return false;
            }
            let size = file.size;
            if(size > 1900000){
                this.$message.error('文件过大，请重新选择!');
                return false;
            }
            size = size + this.templateSize;
            if(size > 1900000){
                this.$message.error('当前模板容量已超出！');
                return false;
            }
            // this.calculateSize();
        },
        calculateSize(){
            let that = this;
            this.templateSize = 0;
            this.templateList.forEach(function(cobj){
                that.templateSize = that.templateSize + cobj.size;
            });
            this.width = "width:" + (this.templateSize/1900000*100) + "%";
            if(this.templateSize < 1000){
                this.viewSize = this.templateSize+'B';
            }
            else if(this.templateSize>=1000 && this.templateSize < 1000000){
                this.viewSize = (this.templateSize/1000).toFixed(2)+'KB';
            }else if(this.templateSize >=1000000){
                this.viewSize = (this.templateSize/1000/1000).toFixed(2)+'MB';
            }
        },
        uploadImgSuccess(response){
            //console.log(JSON.stringify(response));
            if (response.code === '0000000') {
                this.templateList.forEach(function(cobj){
                    cobj.current = false;   
                });
                let index = this.templateList.length;
                this.templateList.push({'index':index+1,'templateType':'img','templateContent': response.txtPath,'contentCode':'','current':true,'size':response.mobileNum,'poster':''});
                this.templateType = '图片内容';
                index = index + 1;
                this.index = index;
                this.templateContent = response.txtPath;
                
            }
            this.calculateSize();
        },
        beforeUploadVideo(file){
            if (['video/mp4','video/3gp','video/3gpp'].indexOf(file.type) == -1) {
                this.$message.error('文件格式暂不支持！');
                return false;
            }
            let size = file.size;
            if(size > 1900000){
                this.$message.error('文件过大，请重新选择!');
                return false;
            }
            size = size + this.templateSize;
            if(size > 1900000){
                this.$message.error('当前模板容量已超出！');
                return false;
            }
        },
        uploadVideoSuccess(response){
            // console.log(JSON.stringify(response));
            if (response.code === '0000000') {
                this.templateList.forEach(function(cobj){
                    cobj.current = false;   
                });
                let index = this.templateList.length;
                this.templateList.push({'index':index+1,'templateType':'video','templateContent': response.txtPath,'contentCode':'','current':true,'size':response.mobileNum,'poster':response.srcFileName});
                this.templateType = '视频内容';
                index = index + 1;
                this.index = index;
                this.templateContent = response.txtPath;
                // console.log(JSON.stringify(this.templateList));
                //console.log('this.templateContent=' + this.templateContent);
            }
            this.calculateSize();
        },
        beforeUploadAudio(file){
            if (['audio/mp3'].indexOf(file.type) == -1) {
                this.$message.error('文件格式暂不支持！');
                return false;
            }
            let size = file.size;
            if(size > 1900000){
                this.$message.error('文件过大，请重新选择!');
                return false;
            }
            size = size + this.templateSize;
            if(size > 1900000){
                this.$message.error('当前模板容量已超出！');
                return false;
            }
        },
        uploadAudioSuccess(response){
            // console.log(JSON.stringify(response));
            if (response.code === '0000000') {
                this.templateList.forEach(function(cobj){
                    cobj.current = false;   
                });
                let index = this.templateList.length;
                this.templateList.push({'index':index+1,'templateType':'audio','templateContent': response.txtPath,'contentCode':'','current':true,'size':response.mobileNum,'poster':''});
                this.templateType = '音频内容';
                index = index + 1;
                this.index = index;
                this.templateContent = response.txtPath;
                
            }
            this.calculateSize();
        },
        moveUp(){
            let index = this.index;
            if(index == 1){
                this.$message.error('已在顶部！')
            }
            else{
                let newIndex = index - 1;
                let newList = [];

                for(var i = 1; i< newIndex; i++){                    
                    this.templateList.forEach(function(cobj){
                        if(i == cobj.index){
                            newList.push(cobj);
                        }
                    });                  
                }
                this.templateList.forEach(function(cobj){
                    if(index == cobj.index){
                        newList.push({'index':newIndex,'templateType':cobj.templateType,'templateContent': cobj.templateContent,'contentCode':'','current':true,'size':cobj.size,'poster':''});
                    }
                });
                this.templateList.forEach(function(cobj){
                    if(newIndex == cobj.index){
                        newList.push({'index':index,'templateType':cobj.templateType,'templateContent': cobj.templateContent,'contentCode':'','current':false,'size':cobj.size,'poster':''});
                    }
                });
                for(var i=index+1; i<=this.templateList.length;i++){
                    this.templateList.forEach(function(cobj){
                        if(i == cobj.index){
                            newList.push(cobj);
                        }
                    });
                }
                this.index = newIndex;
                this.templateList = newList;
            }
        },
        moveDown(){
            let index = this.index;
            if(index == this.templateList.length){
                this.$message.error('已在底部！')
            }
            else{
                let newIndex = this.index + 1;
                let newList = [];
                for(var i = 1; i< index; i++){
                    this.templateList.forEach(function(cobj){
                        if(i == cobj.index){
                            cobj.current = false;
                            newList.push(cobj);
                        }
                    });                    
                }
                this.templateList.forEach(function(cobj){
                    if(newIndex == cobj.index){
                        newList.push({'index':index,'templateType':cobj.templateType,'templateContent': cobj.templateContent,'contentCode':'','current':false,'size':cobj.size,'poster':''});
                    }
                });
                this.templateList.forEach(function(cobj){
                    if(index == cobj.index){
                        newList.push({'index':newIndex,'templateType':cobj.templateType,'templateContent': cobj.templateContent,'contentCode':'','current':true,'size':cobj.size,'poster':''});
                    }
                });
                for(var i=newIndex+1; i<=this.templateList.length;i++){
                    this.templateList.forEach(function(cobj){
                        if(i == cobj.index){
                            cobj.current = false;
                            newList.push(cobj);
                        }
                    });
                }
                this.index = newIndex;
                this.templateList = newList;
            }
        },
        delTemplate(){
            let newList = [];
            let index = 1;
            let that = this;
            this.templateList.forEach(function(cobj){
                if(that.index != cobj.index){
                    newList.push({'index':index,'templateType':cobj.templateType,'templateContent': cobj.templateContent,'contentCode':'','current':cobj.current,'size':cobj.size,'poster':''});
                    index++;
                }
            });
            console.log(JSON.stringify(newList));
            this.templateList = newList;
            this.index = this.index - 1;
            if(this.index <= 0){
                this.index = 1;
            }
            if(this.templateList.length == 0){
                this.templateType = '';
                this.templateContent = '';
            }
            this.templateList.forEach(function(cobj){
                if(that.index == cobj.index){
                    cobj.current = true;
                    if('txt' == cobj.templateType){
                        that.templateType = "文字内容";
                    }
                    else if('img' == cobj.templateType){
                        that.templateType = "图片内容";
                    }
                    else if('video' == cobj.templateType){
                        that.templateType = "视频内容";
                    }
                    else if('audio' == cobj.templateType){
                        that.templateType = "音频内容";
                    }
                    that.templateContent = cobj.templateContent;                 
                }
            });
            this.calculateSize();
        },
        showTemplate(index){
            let that = this;
            this.index = index;
            this.templateList.forEach(function(cobj){
                if(cobj.index == index){
                    cobj.current = true;
                    if('txt' == cobj.templateType){
                        that.templateType = "文字内容";
                    }
                    else if('img' == cobj.templateType){
                        that.templateType = "图片内容";
                    }
                    else if('video' == cobj.templateType){
                        that.templateType = "视频内容";
                    }
                    else if('audio' == cobj.templateType){
                        that.templateType = "音频内容";
                    }
                    that.templateContent = cobj.templateContent;
                }
                else{
                    cobj.current = false;
                }
            });
        },
        previewTemplate(){
            if(this.title == undefined || this.title.trim().length < 1){
                this.$message.error('请先填写模板主题！');
                return;
            }
            if(this.templateList == undefined || this.templateList.length < 1){
                this.$message.error('请填写模板发送内容！');
                return;
            }
            $(".tip1").fadeIn(200);
            $(".tiptop a").click(function(){
                $(".tip1").fadeOut(200);
            })
        },
        checkok(){

        },
        close(){
            $(".tip1").fadeOut(200);
        },
        saveDraft( ){
            let that = this;
            if(this.title == undefined || this.title.trim().length < 1){
                this.$message.error('请先填写模板主题！');
                return;
            }
            if(this.templateList == undefined || this.templateList.length < 1){
                this.$message.error('请填写模板发送内容！');
                return;
            }
            let typeCount = 1;
            let typeContent = '';
            this.templateList.forEach(function(obj){
                if(''==typeContent){
                    typeContent = obj.templateType;
                }
                else{
                    if(typeContent.indexOf(obj.templateType)==-1){
                        typeContent = typeContent + "," + obj.templateType;
                        typeCount++;
                    }
                }
            });
            //console.log(typeCount + ":" + typeContent);
            if(typeCount <= 1){
                this.$message.error('模板内容不能纯文字、纯音频、纯视频、纯图片, 至少两两组合！');
                return;
            }
            if(this.id == '')
            {
                let data = {'title':this.title,'state':3,'list':this.templateList};
                this.$ajax({
                    method: 'post',
                    url: this.GLOBAL.serverSrc + '/sms/savevideosmstemplate.json',
                    data: data,
                    headers: {
                        'Content-Type': 'application/json; charset=UTF-8',
                        'token' : this.GLOBAL.token
                    }
                }).then(function(res) {
                    //console.log(JSON.stringify(res));
                    if('0000000' == res.data.code)
                    {
                        that.$message.success("保存模板成功！");
                        that.$router.push('/videosmstemplate');
                    }
                    else
                    {
                        alert(res.data.msg)
                    }
                })
            }
            else{
                let data = {'title':this.title,'state':3,'list':this.templateList,id:this.id};
                this.$ajax({
                    method: 'post',
                    url: this.GLOBAL.serverSrc + '/sms/updvideosmstemplate.json',
                    data: data,
                    headers: {
                        'Content-Type': 'application/json; charset=UTF-8',
                        'token' : this.GLOBAL.token
                    }
                }).then(function(res) {
                    //console.log(JSON.stringify(res));
                    if('0000000' == res.data.code)
                    {
                        that.$message.success("保存模板成功！");
                    }
                    else
                    {
                        alert(res.data.msg)
                    }
                })
            }
            
        },
        saveTemplate(){
            let that = this;
            if(this.title == undefined || this.title.trim().length < 1){
                this.$message.error('请先填写模板主题！');
                return;
            }
            if(this.templateList == undefined || this.templateList.length < 1){
                this.$message.error('请填写模板发送内容！');
                return;
            }
            // console.log('size:' +this.templateSize);
            // if(this.templateSize < 500000){
            //     this.$message.error('模板大小要在500K以上');
            //     return;
            // }
            let typeCount = 1;
            let typeContent = '';
            let isTxt = 0;
            let isSign = 0;
            this.templateList.forEach(function(obj){
                if(''==typeContent){
                    typeContent = obj.templateType;
                }
                else{
                    if(typeContent.indexOf(obj.templateType)==-1)
                    {
                        typeContent = typeContent + "," + obj.templateType;
                        typeCount++;
                    }
                }
                if('txt' == obj.templateType){
                    isTxt++;
                    if(obj.templateContent.indexOf('【') != -1 && obj.templateContent.indexOf('】')!=-1 
                        && obj.templateContent.indexOf('】') > obj.templateContent.indexOf('【') && obj.templateContent.indexOf('【') == 0){
                        isSign++;
                    }
                }                
            });
            // console.log(isTxt + ":" + isSign);
            if(isTxt == 0 || isSign == 0){
                this.$message.error('模板内容至少含有一个文本，并且含有签名,并且签名放在最前面！');
                return;
            }
            if(typeCount <= 1){
                this.$message.error('模板内容不能纯文字、纯音频、纯视频、纯图片, 至少两两组合！');
                return;
            }
            // return;
            if(this.id == ''){
                let data = {'title':this.title,'state':0,'list':this.templateList};
                this.$ajax({
                    method: 'post',
                    url: this.GLOBAL.serverSrc + '/sms/savevideosmstemplate.json',
                    data: data,
                    headers: {
                        'Content-Type': 'application/json; charset=UTF-8',
                        'token' : this.GLOBAL.token
                    }
                }).then(function(res) {
                    if('0000000' == res.data.code)
                    {
                        that.$message.success("提交审核成功！");
                        that.$router.push('/videosmstemplate');
                    }
                    else
                    {
                        alert(res.data.msg)
                    }
                })
            }
            else{
                let data = {'title':this.title,'state':0,'list':this.templateList,id:this.id};
                this.$ajax({
                    method: 'post',
                    url: this.GLOBAL.serverSrc + '/sms/updvideosmstemplate.json',
                    data: data,
                    headers: {
                        'Content-Type': 'application/json; charset=UTF-8',
                        'token' : this.GLOBAL.token
                    }
                }).then(function(res) {
                    if('0000000' == res.data.code)
                    {
                        that.$message.success("提交审核成功！");
                        that.$router.push('/videosmstemplate');
                    }
                    else
                    {
                        alert(res.data.msg)
                    }
                })
            }
        },
        // delTemplate(id){
        //     if(confirm('此操作将永久删除该条数据, 是否继续?')){
        //         let data = {id:this.id};
        //         this.$ajax({
        //             method: 'post',
        //             url: this.GLOBAL.serverSrc + '/sms/delvideosmstemplate.json',
        //             data: data,
        //             headers: {
        //                 'Content-Type': 'application/json; charset=UTF-8',
        //                 'token' : this.GLOBAL.token
        //             }
        //         }).then(function(res) {
        //             if('0000000' == res.data.code)
        //             {
        //                 that.$message.success("视频模板删除成功！");
        //             }
        //             else
        //             {
        //                 alert(res.data.msg)
        //             }
        //         })
        //     }
        // }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/sms/videosmstemplateadd.vue